import {
  GET_EXCO_KECAMATAN,
  GET_EXCO_KECAMATAN_SUCCESS,
  GET_EXCO_KECAMATAN_FAIL,
} from "./actionTypes";

const initialState = {
  dataKecamatan: {
    loading: false,
    error: false,
    data: null,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EXCO_KECAMATAN:
      return {
        ...state,
        dataKecamatan: {
          ...state.dataKecamatan,
          loading: true,
          error: false,
          isLoggedIn: false,
        },
      };
    case GET_EXCO_KECAMATAN_SUCCESS:
      return {
        ...state,
        dataKecamatan: {
          ...state.dataKecamatan,
          loading: false,
          error: false,
          isLoggedIn: true,
          data: action.payload,
        },
      };
    case GET_EXCO_KECAMATAN_FAIL:
      return {
        ...state,
        dataKecamatan: {
          ...state.dataKecamatan,
          loading: false,
          error: action.payload,
          isLoggedIn: false,
        },
      };
    default:
      return state;
  }
};

export default reducer;
